import { render, staticRenderFns } from "./salary-mapping-detail.vue?vue&type=template&id=655fd708"
import script from "./salary-mapping-detail.vue?vue&type=script&lang=js"
export * from "./salary-mapping-detail.vue?vue&type=script&lang=js"
import style0 from "./salary-mapping-detail.vue?vue&type=style&index=0&id=655fd708&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports